export const PICTREE_REVIEW_MAP = {
  "WITHOUT_REVIEW": "レビューなし",
  "AI_REVIEW_ONLY": "AIレビューのみ",
  "OPERATOR_REVIEW_ONLY": "運用者のみ",
  "OPERATOR_REVIEW_IF_AI_REVIEW_NG": "AIレビューNG時に運用者レビュー",
}
